import { useTheme } from 'vuetify';
import { toRefs, reactive } from 'vue';

/**
 *
 */
export function useColors() {
  const { colors } = useTheme().themes.value.light;

  return { ...toRefs(reactive(colors)) };
}
